import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        path: "/common/kcp/cert/request",
        component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
        props: true,
    },
    {
        path: "/common/kcp/cert/response",
        component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
        props: true,
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - Y-Knowledge 자문관리
        path: "/console/counsels/:type",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/counsels/CounselListPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Y-Factory 서비스관리
        path: "/console/services/:category",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/services/ProgramListPage.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - 교육 목록
        path: "/console/programs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/program/ProgramList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 교육 상세
        path: "/console/programs/:_program",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/program/ProgramView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 교육 상세
        path: "/console/programs/:_program/:tab",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/program/ProgramView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 교육 카테고리 목록
        path: "/console/program-categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/program/ProgramCategoryList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 교육 키워드 목록
        path: "/console/program-keywords",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/program/ProgramKeywordList.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - 설비 목록
        path: "/console/rental-subjects",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/rental/RentalSubjectList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 설비예약 목록
        path: "/console/rental-schedules",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/rental/RentalScheduleList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 설비예약요청 목록
        path: "/console/rental-requests",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/rental/RentalRequestList.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - 라인현황
        path: "/console/mes-dashboard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/mes/MesDashboardView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 부품목록
        path: "/console/mes-materials",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/mes/MesMaterialList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 자재명세서 목록
        path: "/console/mes-boms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/mes/MesBomList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 생산보고서 목록
        path: "/console/mes-reports",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/mes/MesReportList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 생산보고서 상세
        path: "/console/mes-reports/:process/:planDate",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/mes/MesReportView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 생산관리 - 자재 관리
        path: "/console/manufacturing/material-categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/manufacturing/material-categories/MaterialCategoryList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 생산관리 - 자재 관리
        path: "/console/manufacturing/materials",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/manufacturing/ManufacturingMaterialList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 생산관리 - 자재 연동
        path: "/console/manufacturing/materials/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/manufacturing/ManufacturingMaterialView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 생산관리 - 벤더 관리
        path: "/console/manufacturing/vendors",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/manufacturing/ManufacturingVendorList.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/isWithdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 1:1문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 배너관리
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 배너관리
        path: "/console/banners/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 배너관리
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 팝업관리
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 팝업관리
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 문자/알림톡 셋업
        path: "/console/messages",
        name: "console-messages",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/messages/MessagesView.vue"),
        props: true,
        scope: ["console"],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("accessToken") ? `Bearer ${sessionStorage.getItem("accessToken")}` : "";
    axios.defaults.headers.common["Accept-Language"] = i18n.locale;

    next();
});

export default router;
